/**
 * useFitBounds.js
 * Automatically fits the map view to show all visible markers.
 *
 * Rules:
 *  - 0 latLngs → reset to MP default center/zoom
 *  - 1 latLng  → setView with singleMarkerZoom
 *  - 2+ latLngs → fitBounds with padding
 */
import L from 'leaflet';
import { MAP_DEFAULTS } from '../constants/mapDefaults';

/**
 * @param {L.Map} map
 * @returns {{ fit, resetView }}
 */
export function createFitBoundsManager(map) {
  /**
   * Fit map to the supplied array of L.LatLng objects.
   * Call this after markers are added or filters change.
   * @param {L.LatLng[]} latLngs
   */
  function fit(latLngs = []) {
    if (!map) return;

    if (latLngs.length === 0) {
      resetView();
    } else if (latLngs.length === 1) {
      map.setView(latLngs[0], MAP_DEFAULTS.singleMarkerZoom, { animate: true });
    } else {
      try {
        const bounds = L.latLngBounds(latLngs);
        map.fitBounds(bounds, { padding: MAP_DEFAULTS.fitPadding, animate: true, maxZoom: 14 });
      } catch {
        resetView();
      }
    }
  }

  function resetView() {
    map.setView(MAP_DEFAULTS.center, MAP_DEFAULTS.zoom, { animate: true });
  }

  return { fit, resetView };
}
